/*
 * The module's typed translator: core's accessor over this module's own catalogue, so a key that is
 * not in `en` and a missing placeholder are both compile errors inside the module, which is what makes
 * `react/jsx-no-literals` affordable here.
 *
 * The catalogue is imported as a *type*. Its text is the namespace the module hands the router from
 * `i18n()` (`../index.ts`), which the router registers before the first render; importing `en` as a
 * value here would pull the module's whole copy — every screen imports this file — into the entry
 * chunk, which `scripts/checkBudgets.ts` refuses by name.
 */

import { namespaceT } from "../../../core/i18n/index.ts"
import type { ArgsOf } from "../../../core/i18n/t.ts"
import type { en } from "./en.ts"

export type AichatCatalogue = typeof en
export type AichatKey = keyof AichatCatalogue
export type AichatArgs<K extends AichatKey> = ArgsOf<AichatCatalogue, K>

/**
 * The keys of this module whose text carries no placeholder. A lookup table from a closed set the
 * server sends to the word for it is typed with this rather than with `AichatKey`, because `t(key)`
 * can only be called without arguments when every key in the union needs none.
 */
export type PlainAichatKey = {
	[K in AichatKey]: [keyof AichatArgs<K>] extends [never] ? K : never
}[AichatKey]

/** The text of one AI chats key, with its placeholders filled in. */
export const t = namespaceT<AichatCatalogue>("aichat")
